<form [formGroup]="form" fxLayout="column" fxLayoutAlign="start start" class="w-100 mt-16">
    <div class="grid-form-container">
        <af-phone-number class="w-100"
                         widthClass="w-100"
                         [control]="form.controls.msisdn"
                         [disabled]="lockedControls.includes(form.controls.msisdn)"
                         [selectedPhoneInfoControl]="form.controls.selectedPhoneInfo"
                         label="i18n_af_labelMsisdnFraudPhone"/>

        <af-dictionary-selector [dictionaryName]="ReferenceBookType.MOBILE_OPERATOR"
                                [control]="form.controls.operator"
                                label="i18n_af_labelMsisdnFraudOperator"
                                placeholder="i18n_af_placeholderMsisdnFraudOperator"/>
    </div>

    <div class="grid-form-container mt-24">
        <af-date-picker-field labelTranslationKey="i18n_af_labelMsisdnFraudActivationDate"
                              placeholderTranslationKey="i18n_af_placeholderDate"
                              displayFormat="DD.MM.YYYY"
                              [form]="form.controls.activationDate"
                              [supportedDateFormat]="['DDMMYYYY', 'DD.MM.YYYY']"
                              [dateFormats]="DATE_TIME_FORMATS"/>

        <af-date-picker-field labelTranslationKey="i18n_af_labelMsisdnFraudTerminationDate"
                              placeholderTranslationKey="i18n_af_placeholderDate"
                              displayFormat="DD.MM.YYYY"
                              [form]="form.controls.terminationDate"
                              [supportedDateFormat]="['DDMMYYYY', 'DD.MM.YYYY']"
                              [dateFormats]="DATE_TIME_FORMATS"/>
    </div>

    <div class="grid-form-container mt-24">
        <af-dictionary-selector [dictionaryName]="ReferenceBookType.MSISDN_STATUS"
                                [control]="form.controls.status"
                                label="i18n_af_labelMsisdnFraudStatus"
                                placeholder="i18n_af_placeholderMsisdnFraudStatus"/>

        <af-dictionary-selector [dictionaryName]="ReferenceBookType.MOBILE_OPERATOR_EVENT_SOURCE"
                                [control]="form.controls.reason"
                                label="i18n_af_labelMsisdnFraudReason"
                                placeholder="i18n_af_placeholderMsisdnFraudReason"/>
    </div>

    <div class="grid-form-container mt-24">
        <af-date-picker-field labelTranslationKey="i18n_af_labelMsisdnFraudContactDate"
                              placeholderTranslationKey="i18n_af_placeholderContactDate"
                              displayFormat="DD.MM.YYYY HH:MM"
                              [form]="form.controls.contactDate"
                              [showPickerActions]="true"
                              [supportedDateFormat]="['DDMMYYYYHHMM', 'DD.MM.YYYY HH:MM']"
                              [dateFormats]="DATE_TIME_FORMATS"/>
    </div>

    <div class="grid-form-container mt-24">
        <af-dictionary-selector [dictionaryName]="ReferenceBookType.SUBSCRIBER_CATEGORY"
                                [control]="form.controls.category"
                                label="i18n_af_labelMsisdnFraudCategory"
                                placeholder="i18n_af_placeholderMsisdnFraudCategory"/>

        <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
            <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelMsisdnFraudIsResident' | translate }} *</div>
            <mat-form-field class="w-100 mt-4"
                            [class.value-not-empty]="form.controls.isResident.value !== null">
                <mat-select [formControl]="form.controls.isResident"
                            hideSingleSelectionIndicator
                            class="h-100"
                            fxLayoutAlign="start center"
                            [placeholder]="'i18n_af_placeholderMsisdnFraudIsResident' | translate">
                    <mat-option [value]="true">{{ 'i18n_af_residentStatus#resident' | translate }}</mat-option>
                    <mat-option [value]="false">{{ 'i18n_af_residentStatus#nonResident' | translate }}</mat-option>
                </mat-select>
                <ui-kit-svg matSuffix class="i-16 mr-16 pointer c-primary-gray-600" name="ic_arrow_down"/>
            </mat-form-field>
        </div>
    </div>

    @if (form.controls.isResident.value === true) {
        <div class="grid-form-container mt-24">
            <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelMsisdnFraudIin' | translate }} *</div>
                <mat-form-field class="w-100 mt-4"
                                [class.value-not-empty]="form.controls.iin.value">
                    <input matInput
                           [formControl]="form.controls.iin"
                           mask="000000000000"
                           [placeholder]="'i18n_af_placeholderMsisdnFraudIin' | translate"
                           name="iin"/>
                    @if (form.controls.iin.hasError('required')) {
                        <mat-error class="c-secondary-red-900">
                            {{ 'i18n_af_fieldValidationRequired' | translate }}
                        </mat-error>
                    }
                    @if (form.controls.iin.hasError('pattern')) {
                        <mat-error class="c-secondary-red-900">
                            {{ 'i18n_af_fieldValidationIinPattern' | translate }}
                        </mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
    }

    @if (form.controls.isResident.value === false) {
        <div class="grid-form-container mt-24">
            <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelMsisdnFraudPassportNumber' | translate }} *</div>
                <mat-form-field class="w-100 mt-4"
                                [class.value-not-empty]="form.controls.passportNumber.value">
                    <input matInput
                           [formControl]="form.controls.passportNumber"
                           maxlength="255"
                           [placeholder]="'i18n_af_placeholderMsisdnFraudPassportNumber' | translate"
                           name="passportNumber"/>
                    @if (form.controls.passportNumber.hasError('required')) {
                        <mat-error class="c-secondary-red-900">
                            {{ 'i18n_af_fieldValidationRequired' | translate }}
                        </mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
    }

    <div class="grid-form-container mt-24">
        <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
            <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelMsisdnFraudLastName' | translate }} *</div>
            <mat-form-field class="w-100 mt-4"
                            [class.value-not-empty]="form.controls.lastName.value">
                <input matInput
                       [formControl]="form.controls.lastName"
                       maxlength="255"
                       [placeholder]="'i18n_af_placeholderMsisdnFraudLastName' | translate"
                       name="lastName"/>
                @if (form.controls.lastName.hasError('required')) {
                    <mat-error class="c-secondary-red-900">
                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                    </mat-error>
                }
            </mat-form-field>
        </div>

        <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
            <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelMsisdnFraudFirstName' | translate }} *</div>
            <mat-form-field class="w-100 mt-4"
                            [class.value-not-empty]="form.controls.firstName.value">
                <input matInput
                       [formControl]="form.controls.firstName"
                       maxlength="255"
                       [placeholder]="'i18n_af_placeholderMsisdnFraudFirstName' | translate"
                       name="firstName"/>
                @if (form.controls.firstName.hasError('required')) {
                    <mat-error class="c-secondary-red-900">
                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                    </mat-error>
                }
            </mat-form-field>
        </div>
    </div>

    <div class="grid-form-container mt-24">
        <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
            <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelMsisdnFraudMiddleName' | translate }}</div>
            <mat-form-field class="w-100 mt-4"
                            [class.value-not-empty]="form.controls.middleName.value">
                <input matInput
                       [formControl]="form.controls.middleName"
                       maxlength="255"
                       [placeholder]="'i18n_af_placeholderMsisdnFraudMiddleName' | translate"
                       name="middleName"/>
            </mat-form-field>
        </div>

        @if (form.controls.isResident.value) {
            <af-dictionary-selector [dictionaryName]="ReferenceBookType.COUNTRY"
                                    [control]="form.controls.country"
                                    [predefinedValue]="lockedControls.includes(form.controls.country) ? null : '398'"
                                    [disabled]="lockedControls.includes(form.controls.country)"
                                    label="i18n_af_labelMsisdnFraudCountry"
                                    placeholder="i18n_af_placeholderCountry"/>
        } @else {
            <af-dictionary-selector [dictionaryName]="ReferenceBookType.COUNTRY"
                                    [control]="form.controls.country"
                                    [disabled]="lockedControls.includes(form.controls.country)"
                                    label="i18n_af_labelMsisdnFraudCountry"
                                    placeholder="i18n_af_placeholderCountry"/>
        }
    </div>

    <div fxLayout="column" fxLayoutAlign="start start" class="w-824 mt-40">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100">
            <div class="t2-semi-bold c-primary-gray-900">{{ 'i18n_af_labelSubscriberMsisdns' | translate }}</div>
            @if (canAddMoreSubscriberMsisdns) {
                <ui-kit-button type="text"
                               iconPosition="left"
                               icon="ic_add_circle"
                               (clickListener)="addSubscriberMsisdn()"
                               [label]="'i18n_af_buttonAddSubscriberMsisdn' | translate"/>
            }
        </div>
        @if (form.controls.subscriberMsisdns.length > 0) {
            <div class="grid-form-container w-100 mt-16">
                @for (msisdnGroup of form.controls.subscriberMsisdns.controls; track msisdnGroup; let i = $index) {
                    <div fxLayout="row" fxLayoutAlign="start center" class="w-100">
                        <af-phone-number class="w-100"
                                         widthClass="w-100"
                                         [control]="msisdnGroup.controls.msisdn"
                                         [disabled]="lockedControls.includes(msisdnGroup)"
                                         [selectedPhoneInfoControl]="msisdnGroup.controls.selectedPhoneInfo"
                                         [label]="'i18n_af_labelMsisdnFraudSubscriberPhone'"/>
                        @if (!lockedControls.includes(msisdnGroup)) {
                            <ui-kit-svg
                                class="i-24 ml-8 pointer c-secondary-red-900 mt-20"
                                name="ic_delete"
                                (click)="removeSubscriberMsisdn(i)"/>
                        }
                    </div>
                }
            </div>
        }
    </div>
</form>
